/**
 * Centralized label dictionaries for ZENTRA enums.
 */
export const PROPERTY_STATE_LABELS = {
    free: { label: "Libre", color: "bg-zentra-bg text-zentra-ink border-zentra-border" },
    occupied: { label: "Ocupado", color: "bg-zentra-primary text-white border-zentra-primary" },
    checkout_today: { label: "Salida hoy", color: "bg-amber-100 text-amber-900 border-amber-200" },
    checkin_today: { label: "Entrada hoy", color: "bg-sky-100 text-sky-900 border-sky-200" },
    pending_cleaning: { label: "Pendiente limpieza", color: "bg-orange-100 text-orange-900 border-orange-200" },
    cleaned: { label: "Limpio", color: "bg-emerald-100 text-emerald-900 border-emerald-300" },
    under_review: { label: "En revisión", color: "bg-violet-100 text-violet-900 border-violet-200" },
    blocked: { label: "Bloqueado", color: "bg-red-100 text-red-800 border-red-200" },
    maintenance: { label: "Mantenimiento", color: "bg-zinc-200 text-zinc-800 border-zinc-300" },
};

export const TASK_STATE_LABELS = {
    pending: { label: "Pendiente", color: "bg-zentra-bg text-zentra-ink border-zentra-border" },
    in_progress: { label: "En curso", color: "bg-sky-100 text-sky-900 border-sky-200" },
    completed: { label: "Completada", color: "bg-emerald-100 text-emerald-900 border-emerald-300" },
    validated: { label: "Validada", color: "bg-zentra-accent/20 text-zentra-primary border-zentra-accent" },
    delayed: { label: "Retrasada", color: "bg-red-100 text-red-800 border-red-200" },
};

export const TASK_TYPE_LABELS = {
    checkout: "Salida huésped",
    checkin_review: "Revisión entrada",
    deep_clean: "Limpieza profunda",
    shock_clean: "Limpieza choque",
    post_work: "Post obra",
    periodic: "Periódica",
    maintenance: "Mantenimiento",
};

export const PRIORITY_LABELS = {
    critical: { label: "Crítica", color: "bg-red-600 text-white border-red-700" },
    high: { label: "Alta", color: "bg-orange-500 text-white border-orange-600" },
    medium: { label: "Media", color: "bg-amber-300 text-amber-950 border-amber-400" },
    low: { label: "Baja", color: "bg-zentra-bg text-zentra-muted border-zentra-border" },
};

export const INCIDENT_STATE_LABELS = {
    open: { label: "Abierta", color: "bg-zentra-bg text-zentra-ink border-zentra-border" },
    assigned: { label: "Asignada", color: "bg-sky-100 text-sky-900 border-sky-200" },
    in_progress: { label: "En curso", color: "bg-amber-100 text-amber-900 border-amber-200" },
    awaiting_material: { label: "Esperando material", color: "bg-violet-100 text-violet-900 border-violet-200" },
    resolved: { label: "Resuelta", color: "bg-emerald-100 text-emerald-900 border-emerald-300" },
    closed: { label: "Cerrada", color: "bg-zentra-primary text-white border-zentra-primary" },
};

export const INCIDENT_TYPE_LABELS = {
    plumbing: "Fontanería",
    electricity: "Electricidad",
    carpentry: "Carpintería",
    masonry: "Albañilería",
    appliances: "Electrodomésticos",
    hvac: "Climatización",
    locksmith: "Cerrajería",
    guest_damage: "Daño huésped",
    aesthetic: "Estético",
    emergency: "Urgencia 24h",
};

export const ROLE_LABELS = {
    admin: "Administrador",
    coordinator: "Coordinador",
    supervisor: "Supervisor calidad",
    cleaner: "Operario limpieza",
    technician: "Técnico mantenimiento",
    warehouse: "Almacén",
    client: "Cliente",
};

export const INVENTORY_CATEGORY_LABELS = {
    cleaning: "Limpieza",
    amenities: "Amenities",
    textile: "Textil",
    consumables: "Consumibles",
    epi: "EPI",
    spare: "Repuestos",
    tools: "Herramientas",
};

export const INVENTORY_LOCATION_LABELS = {
    main_warehouse: "Almacén principal",
    laundry: "Lavandería",
    tech_van: "Furgo técnica",
    apartment: "En apartamento",
};

export const TEXTILE_CATEGORY_LABELS = {
    sheet: "Sábanas",
    duvet_cover: "Fundas nórdicas",
    pillowcase: "Fundas almohada",
    towel_bath: "Toallas baño",
    towel_face: "Toallas cara",
    towel_kitchen: "Paños cocina",
    blanket: "Mantas",
    mattress_cover: "Cubrecolchones",
    tablecloth: "Manteles",
    other: "Otros",
};

export const TEXTILE_STATE_LABELS = {
    clean: { label: "Limpia", color: "bg-emerald-100 text-emerald-900 border-emerald-300" },
    at_apartments: { label: "En apartamento", color: "bg-sky-100 text-sky-900 border-sky-200" },
    dirty: { label: "Sucia", color: "bg-amber-100 text-amber-900 border-amber-200" },
    in_transit: { label: "En tránsito", color: "bg-violet-100 text-violet-900 border-violet-200" },
    lost: { label: "Pérdida", color: "bg-red-100 text-red-800 border-red-200" },
};

export const LAUNDRY_BATCH_STATE_LABELS = {
    open: { label: "Abierto", color: "bg-zentra-bg text-zentra-ink border-zentra-border" },
    in_transit: { label: "En lavandería", color: "bg-violet-100 text-violet-900 border-violet-200" },
    returned: { label: "Devuelto", color: "bg-sky-100 text-sky-900 border-sky-200" },
    closed: { label: "Cerrado", color: "bg-emerald-100 text-emerald-900 border-emerald-300" },
};
